<template>
  <div class="cus">
    <div>
      <div class="cus-title">
        <div class="cus-title-icon"></div>
        <div class="cus-title-title">湖南檀浏信息技术有限公司</div>
      </div>
      <div class="cus-title-desc">Hunan tanliu Information Technology Co., Ltd</div>
      <div class="cus-title-content">
        <p>湖南檀浏信息技术有限公司是国内专注的IT服务的软件公司。</p>
        <p>公司位于湖南长沙市，提供以品牌电子商务为核心的一站式商业解决方案，涉及B2B、B2C、B2B2C等电商系统。</p>
        <p>我们的业务覆盖从品牌官方商城，到中国最大的线上购物平台天猫与京东，及社交移动商城，线下智能门店等全渠道的构建。</p>
        <p>我们植根于数字世界的商业模式演变，并在供应链各领域深耕细作，为品牌提供定制化解决方案，为消费者打造完美购物体验，构架起品牌与消费者之间的互通桥梁。</p>
        <p>我们的使命是成为连接企业管理与信息技术的桥梁，帮助企业实现数字化转型，以信息化手段帮助客户提高组织的运营效率、效益与竞争能力，实现客户价值。</p>
      </div>
    </div>
    <div class="cus-bg2">
      <div class="cus-bg3"/>
      <img :class="activeIndex==index?'cus-bg active':'cus-bg'" v-for="(item,index) in imgList" :key="index" :src="item"/>
      <div class="point-list">
        <div :class="activeIndex==index?'cus-point active':'cus-point'" v-for="(item,index) in imgList" :key="index" @click="changeIndex('count',index)"></div>
      </div>
      <div class="de-circle"></div>
    </div>
  </div>
</template>

<script>
  var timer;
  export default {
    name: "CUs",
    data() {
      return {
        activeIndex:0,
        count:0,
        imgList: ["../../static/tl2.png", "../../static/5325352.png", "../../static/23423352.png"]
      }
    },
    mounted() {
      timer = setInterval(() => {
        let count = this.count + 1
        this.count = count
        if (count == 5) {
          this.changeIndex('next')
        }
      }, 1000)
    },
    destroyed(){
      timer&&clearInterval(timer)
    },
    methods:{
      changeIndex(type, toIndex) {
        let index = this.activeIndex
        if (type == 'next') {
          index++;
        } else {
          index = toIndex
        }
        index = index % this.imgList.length
        this.activeIndex = index
        this.count = 0
      }
    }
  }
</script>

<style scoped>
  .cus {
    display: flex;
    justify-content: space-between;
    width: 1070px;
    margin: 0 auto;
  }

  .cus-title {
    display: flex;
    height: 34px;
    margin-top: 36px;
  }
  .de-circle{
    width: 33px;
    height: 33px;
    background: #0C16EF;
    box-shadow: 0px 20px 30px 0px rgba(0, 0, 0, 0.3);
    border-radius: 40px;
    position: absolute;
    bottom: 45px;
    right: 125px;
  }

  .cus-title-icon {
    width: 17px;
    height: 17px;
    background: #0C16EF;
    box-shadow: 0px 12px 11px 0px rgba(0, 0, 0, 0.24);
    border-radius: 50%;
  }

  .cus-title-title {
    font-size: 24px;
    font-family: YouSheBiaoTiHei;
    color: #333333;
    line-height: 31px;
    letter-spacing: 1px;
    margin-left: 17px;
  }

  .cus-title-desc {
    font-size: 12px;
    font-family: YouSheBiaoTiHei;
    color: #ACAEC0;
    line-height: 16px;
    margin-top: 2px;
    margin-left: 34px;
  }

  .cus-title-content {
    width: 427px;
    height: 310px;
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #081457;
    line-height: 21px;
  }

  .cus-title-content p {
    text-indent: 32px;
    margin-top: 18px;
  }

  .cus-bg {
    position: absolute;
    top: 15px;
    left: 37px;
    width: 568px;
    height: 347px;
    opacity: 0;
    transition: opacity 1s ease-in-out;
  }
  .cus-bg.active{
    opacity: 1;
    transition: opacity 1s ease-in-out;
  }
  .cus-point{
    width: 9px;
    height: 9px;
    background-color: rgba(255,255,255,0.6);
    margin-right: 6px;
    margin-left: 6px;
    border-radius: 50%;
    cursor: pointer;
  }
  .cus-point.active{
    background-color: rgba(255,255,255,1);
  }
  .point-list{
    width: 100%;
    position: absolute;
    bottom: 72px;
    left: 0;
    display: flex;
    justify-content: center;
  }

  .cus-bg3 {
    background-image: url("../../static/zs1.png");
    position: absolute;
    top: -39px;
    left: 470px;
    width: 324px;
    height: 353px;
  }

  .cus-bg2 {
    background-image: url("../../static/tl.png");
    width: 642px;
    height: 421px;
    margin-top: 50px;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/CUs.vue